import { env } from '@/core/config/env';
import { httpClient } from './httpClient';

export interface CustomerSmsRecipient {
  contactId: string;
  displayName: string;
  mobile: string;
}

export interface CustomerSmsRecipientResult {
  contactId: string;
  displayName: string;
  mobile: string | null;
  status: 'pending' | 'sent' | 'failed' | 'skipped' | 'requiresConfiguration';
  error: string | null;
}

export interface CustomerSmsBatchResponse {
  total: number;
  sent: number;
  failed: number;
  results: CustomerSmsRecipientResult[];
}

export const customerSmsApi = {
  async recipients(search = '', take = 300): Promise<CustomerSmsRecipient[]> {
    if (env.isDemo) return [];
    const query = new URLSearchParams({ take: String(take) });
    if (search.trim()) query.set('search', search.trim());
    return (await httpClient.get<CustomerSmsRecipient[]>(`/api/v1/customer-sms/recipients?${query.toString()}`)).data;
  },
  async send(contactIds: string[], message: string): Promise<CustomerSmsBatchResponse> {
    if (env.isDemo) return { total: contactIds.length, sent: contactIds.length, failed: 0, results: [] };
    const timeoutMs = Math.max(env.requestTimeoutMs, Math.min(300_000, 10_000 + contactIds.length * 1_500));
    return (await httpClient.post<CustomerSmsBatchResponse>('/api/v1/customer-sms/send', { contactIds, message }, { timeoutMs })).data;
  },
};
